module.exports = __webpack_public_path__ + "media/images/flags/64/Tuvalu-955de5a640097b46e04d35c12ae9f108.png";